module.exports = __webpack_public_path__ + "img/isracard-stacked.8255452e.svg";